module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG5f49375157012d5a250313e8d7fe3955.5f493751.png";